<template>
  <div
    class="lg:px-12 md:px-12 px-4 lg:py-12 md:py-12 lg:mb-0 md:mb-0 mb-12 md:mt-0 lg:mt-0 mt-20"
  >
    <div class="cust-88per sm-full mx-auto">
      <p
        class="title sm-fsize16 md:font-normal lg:font-normal font-bold lg:pl-2 md:pl-2 pl-6 mx-auto"
      >
        Partners
      </p>
      <!-- <div class="lg:mt-6 md:mt-5 mt-4 lg:w-9/12 mx-auto">
        <swiper class="swiper swiper2" :options="swiperOptions">
          <swiper-slide
            v-for="(item, index) in AllPartners.data"
            :key="'partner-' + index"
          >
            <div class="lg:px-8" v-if="item.link">
              <a :href="item.link" target="_blank">
                <img
                  :src="`${$imageURL}/${item.picture}`"
                  :alt="item.title"
                  class="flex md:h-32 lg:h-32 md:w-32 lg:w-32 w-12 sm-partner-w img-ratio"
                />
              </a>
            </div>
            <div class="lg:px-8" v-else>
              <img
                :src="`${$imageURL}/${item.picture}`"
                :alt="item.title"
                class="flex md:h-32 lg:h-32 md:w-32 lg:w-32 w-12 sm-partner-w img-ratio"
              />
              <p class="fsize14 font-normal text-gray ellipsis-4 mt-1">
                hjbjkhlkjhkjj
              </p>
            </div>
          </swiper-slide>
          <div class="swiper-button-prev custarrow" slot="button-prev"></div>
          <div class="swiper-button-next custarrow" slot="button-next"></div>
        </swiper>
      </div> -->
      <div class="lg:mt-6 md:mt-5 mt-4 lg:w-9/12 mx-auto">
        <swiper class="swiper" :options="swiperOptions">
          <swiper-slide v-for="(item, index) in AllPartners.data" :key="index">
            <div class="bg-fff p-3 rounded-lg">
              <template v-if="item.link">
                <a :href="item.link" target="_blank">
                  <img
                    :src="`${$imageURL}/${item.picture}`"
                    alt="india"
                    class="h-32 w-32 object-contain mx-auto mb-3"
                  />
                </a>
              </template>
              <template v-else>
                <img
                  :src="`${$imageURL}/${item.picture}`"
                  alt="india"
                  class="h-32 w-32 object-contain mx-auto mb-3"
                />
              </template>

              <div class="text-center">
                <p
                  class="fsize14 font-normal text-gray ellipsis-4 mt-1 heading-style"
                >
                  <span v-html="item.description"></span>
                </p>
                <!-- <a :href="item.link" target="blank">
                  <div
                    class="text-primary flex justify-center gap-1 items-center mt-2"
                  >
                    <p class="">Go to Website</p>
                    <feather-icon
                      icon="ArrowUpRightIcon"
                      class="cursor-pointer"
                      svgClasses="w-4 h-4"
                    ></feather-icon>
                  </div>
                </a> -->
              </div>
            </div>
          </swiper-slide>

          <div class="swiper-button-prev adminswiper" slot="button-prev"></div>
          <div class="swiper-button-next adminswiper" slot="button-next"></div>
        </swiper>
      </div>
    </div>
    <div class="pt-12">
      <div class="relative lg:flex md:flex">
        <div class="absolute bg-design15 mob-hidden">
          <img
            src="../../../assets/images/dots.svg"
            alt="bg-polygon"
            class="h6rem"
          />
        </div>
        <div class="absolute bg-design17 mob-hidden">
          <img
            src="../../../assets/images/Ellipse 12.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design16 mob-hidden">
          <img
            src="../../../assets/images/bg-des/bgd16.svg"
            alt="bg-polygon"
            class=""
          />
        </div>
        <div class="bgcceff2 rounded10rem lg:w-1/2 md:w-1/2 w-full pt-12 z-10">
          <img
            src="https://nimbuscluster.blob.core.windows.net/server01/caregiversaathi/CG/homepage/Joinus.webp"
            alt=""
            class="w-3/5 pt-12 mx-auto"
          />
        </div>
        <div
          class="lg:w-1/2 md:w-1/2 m-auto lg:px-0 md:px-0 px-4 lg:pt-0 md:pt-0 pt-8"
        >
          <div class="lg:px-12 md:px-8">
            <p
              class="title sm-fsize16 md:font-normal lg:font-normal font-bold mb-2 mx-auto"
            >
              Join Us
            </p>
            <p class="subtitle lh32px md-fsize18 sm-fsize14">
              Our goal is to create a paradigm shift in the social narrative of
              a caregiver’s journey, which is unrecognised and often neglected.
              You can contribute in various ways to help achieve this ambition….
            </p>
            <p class="subtitle lh32px md-fsize18 sm-fsize14">
              Learn more about how you can become a part of our community for
              change.
            </p>
            <div class="lg:pt-8 md:pt-8 pt-4">
              <base-button
                type="primary"
                class="btntext md-fsize14 sm-fsize14"
                @click="handleClick('join-us')"
                >Get Involved</base-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.core.css";
import "swiper/dist/css/swiper.min.css";
import { mapState } from "vuex";
export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 3,
        spaceBetween: 20,
        loop: true,
        // pagination: {
        //   el: ".swiper-pagination",
        // },

        breakpoints: {
          1600: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1300: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          900: {
            slidesPerView: 3,
            spaceBetween: 25,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 25,
            slidesPerColumn: 1,
          },
          575: {
            slidesPerView: 1,
            spaceBetween: 25,
            slidesPerColumn: 1,
          },
        },

        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
      },
      partners: [
        // {
        //   image: require("@/assets/images/PartnerLogos/CanSupport-logo.png"),
        // },
        // {
        //   image: require("@/assets/images/CGNEW/aajicare.jpg"),
        // },
        // {
        //   image: require("@/assets/images/partner/mainlogo1.jpg"),
        // },
        // {
        //   image: require("@/assets/images/partner/kewalcare.png"),
        // },
        // {
        //   image: require("@/assets/images/partner/mainlogo0.jpg"),
        // },
        // {
        //   image: require("@/assets/images/partner/toward Equal.png"),
        //   class: "object-contain",
        // },
        // {
        //   image: require("@/assets/images/partner/mainlogo3.jpg"),
        // },
        // {
        //   image: require("@/assets/images/partner/mainlogo4.png"),
        // },
        // {
        //   image: require("@/assets/images/partner/mainlogo5.png"),
        // },
        // {
        //   image: require("@/assets/images/partner/mainlogo6.png"),
        // },
        // {
        //   image: require("@/assets/images/partner/mainlogo7.png"),
        // },
        // {
        //   image: require("@/assets/images/partner/mainlogo8.jpg"),
        // },
        // {
        //   image: require("@/assets/images/partner/mainlogo9.jpg"),
        // },
        // {
        //   image: require("@/assets/images/CGNEW/fellow.png"),
        // },
        // {
        //   image: require("@/assets/images/CGNEW/walmart.jpeg"),
        // },
      ],
    };
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
    async loadPartners() {
      await this.$store.dispatch("partners/getPartners");

      // console.log("1234", this.AllPartners);
    },
  },
  mounted() {
    // console.log("AllPartners", this.AllPartners);

    this.loadPartners();
  },
  computed: {
    ...mapState("partners", ["AllPartners"]),
  },
};
</script>
<style>
.swiper-button-next,
.swiper-button-prev {
  transform: scale(0.5);
  filter: hue-rotate(40deg);
}

@media (max-width: 640px) {
  .custarrow.swiper-button-next {
    right: -20px !important;
  }

  .custarrow.swiper-button-prev {
    left: -20px !important;
  }
}
.custarrow.swiper-button-next {
  right: -6px !important;
}

.custarrow.swiper-button-prev {
  left: -6px !important;
}
.cuistraTIO {
  aspect-ratio: 2/2;
}
.img-ratio {
  width: 100%;
  aspect-ratio: 1/1;
  object-fit: contain;
}
/* .custarrow.swiper-container {
  margin-left: 4rem !important;
  margin-right: 4rem !important;
} */
.ql-size-huge {
  font-size: 2.5em;
}

.ql-size-large {
  font-size: 1.5em;
}

.ql-size-small {
  font-size: 0.75em;
}

.heading-style > h1 {
  font-size: 2.5em;
}

.heading-style > h2 {
  font-size: 1.8em;
}

.heading-style > h3 {
  font-size: 1.5em;
}

.heading-style > h4 {
  font-size: 1.15em;
}

.heading-style > h5 {
  font-size: 1em;
}

.heading-style > h6 {
  font-size: 0.8em;
}
</style>
